module.exports = __webpack_public_path__ + "img/ball-regular.b69e7f9e.svg";